import { useAvatarColor } from 'dashboard/composables/useAvatarColor';

const { avatarColor, initials } = useAvatarColor();

export { avatarColor, initials };
